import { render, staticRenderFns } from "./RegularListBuyBox.vue?vue&type=template&id=5a9d89c8&scoped=true"
import script from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularListBuyBox.vue?vue&type=style&index=0&id=5a9d89c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d89c8",
  null
  
)

export default component.exports